import { render, staticRenderFns } from "./privateChat.vue?vue&type=template&id=8975ffa0&scoped=true"
import script from "./privateChat.vue?vue&type=script&lang=js"
export * from "./privateChat.vue?vue&type=script&lang=js"
import style0 from "./privateChat.vue?vue&type=style&index=0&id=8975ffa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8975ffa0",
  null
  
)

export default component.exports